import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { LoanApplicationDto } from 'src/generated-api-client';
import { LoanApplicationDeclineReasonsTable } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationDeclineReasonsTable';

type LoanApplicationDeclineReasonsTabProps = {
    application?: LoanApplicationDto;
};

export const LoanApplicationDeclineReasonsTab = observer(
    ({ application }: LoanApplicationDeclineReasonsTabProps) => {
        const declineInfo = application?.declineInfo || [];
        const hasDeclineInfo = declineInfo.length !== 0;

        return (
            <Card title={t('LoanApplication.DeclineReasons.Title')}>
                {hasDeclineInfo ? (
                    <LoanApplicationDeclineReasonsTable
                        declineInfo={declineInfo}
                    />
                ) : (
                    t('LoanApplication.DeclineReasons.NoDeclineReasons')
                )}
            </Card>
        );
    },
);
